import Vue from 'vue'
import Router from 'vue-router'
import statistic from '@v2/static/js/statistic'
import client from '../static/client'
import platform from '../static/client/platform'

Vue.use(Router)
let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@v2/components/home/Index')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('@v2/components/demo/Index')
    },
    {
      path: '/Monitor',
      name: 'monitor',
      component: () => import('@v2/components/demo/Monitor')
    },
    {
      path: '/testexit',
      name: 'testExit',
      component: () => import('@v2/components/demo/TestExit')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@v2/components/demo/Test')
    },
    {
      path: '/column/:type', // type 1同名改编 2新游
      name: 'Column',
      component: () => import('@v2/components/home/Column')
    },
    {
      path: '/mine',
      name: 'Mine',
      component: () => import('@v2/components/user/Index')
    },
    {
      path: '/user/recent',
      name: 'RecentGame',
      component: () => import('@v2/components/user/MyGame')
    },
    {
      path: '/user/consumeLog',
      name: 'UserConsumeLog',
      component: () => import('@v2/components/user/ConsumeLog')
    },
    {
      path: '/user/giftLog',
      name: 'UserGiftLog',
      component: () => import('@v2/components/user/GiftLog')
    },
    {
      path: '/user/giftList',
      name: 'UserGiftList',
      component: () => import('@v2/components/user/GiftList')
    },
    {
      path: '/user/messages',
      name: 'UserMessage',
      component: () => import('@v2/components/user/Message')
    },
    {
      path: '/user/message/:id',
      name: 'UserMessageDetail',
      component: () => import('@v2/components/user/MessageDetail')
    },
    {
      path: '/user/notice/:id',
      name: 'UserNoticeDetail',
      component: () => import('@v2/components/user/NoticeDetail')
    },
    {
      path: '/user/coupon',
      name: 'UserCouponList',
      component: () => import('@v2/components/user/CouponList')
    },
    {
      path: '/user/info',
      name: 'UserInfo',
      component: () => import('@v2/components/user/Info')
    },
    // {
    //   path: '/grade',
    //   name: 'Grade',
    //   component: () => import('@v2/components/user/Level')
    // },
    {
      path: '/user/feedbackType',
      name: 'UserFeedbackType',
      component: () => import('@v2/components/user/FeedbackType')
    },
    {
      path: '/user/feedback/:type',
      name: 'UserFeedback',
      component: () => import('@v2/components/user/Feedback')
    },
    {
      path: '/user/couponHistory/:type',
      name: 'UserCouponHistory',
      component: () => import('@v2/components/user/CouponHistory')
    },
    {
      path: '/detail/:gameId',
      name: 'Detail',
      component: () => import('@v2/components/detail/Index')
    },
    {
      path: '/rank/',
      name: 'Rank',
      component: () => import('@v2/components/rank/Index')
    },
    {
      path: '/category/',
      name: 'Category',
      component: () => import('@v2/components/category/Index')
    },
    {
      path: '/error/',
      name: 'Error',
      component: () => import('@v2/components/error/404')
    },
    {
      path: '/activity/:type',
      name: 'Activity',
      component: () => import('@v2/components/activity/Index')
    },
    {
      path: '/fab/:gameId',
      name: 'Fab',
      component: () => import('@v2/components/fab/Index')
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('@v2/components/pay/Index')
    },
    {
      path: '/pay/couponSel',
      name: 'couponSel',
      component: () => import('@v2/components/pay/CouponSel')
    },
    {
      path: '/user/cardPurchaseList/:sno',
      name: 'UserCardPurchaseList',
      component: () => import('@v2/components/user/CardPurchaseList')
    },
    {
      path: '/gift/index',
      name: 'gift',
      component: () => import('@v2/components/gift/center') // todo 准删除页面，临时修改跳转至礼包中心
    },
    {
      path: '/gift/center',
      name: 'giftCenter',
      component: () => import('@v2/components/gift/center')
    },
    {
      path: '/reward',
      name: 'reward',
      component: () => import('@v2/components/reward/Index')
    },
    {
      path: '/balls/:gameId/:ballType',
      name: 'balls',
      component: () => import('@v2/components/balls/Index')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@v2/components/search/Index')
    },
    {
      path: '/favtip/:gameId',
      name: 'favtip',
      component: () => import('@v2/components/favtip/Index')
    },
    {
      path: '/GameCenterShortCut',
      name: 'GameCenterShortCut',
      component: () => import('@v2/components/favtip/GameCenterShortCut')
    },
    {
      path: '/xfq/:gameId',
      name: 'xfq',
      component: () => import('@v2/components/xfq/Index')
    },
    {
      path: '/question/:roleId/:serverId/:userId/:questionId/:platformId',
      name: 'question',
      component: () => import('@v2/components/question/Index')
    },
    {
      path: '/scoreLog',
      name: 'scoreLog',
      component: () => import('@v2/components/fab/ScoreLog')
    },
    {
      path: '/scoreFaq',
      name: 'scoreFaq',
      component: () => import('@v2/components/fab/ScoreFaq')
    },
    {
      path: '/giftFaq',
      name: 'giftFaq',
      component: () => import('@v2/components/faq/Gift')
    },
    {
      path: '/mineGame',
      name: 'mineGame',
      component: () => import('@v2/components/user/RecentGame')
    },
    {
      path: '/mall',
      name: 'mallIndex',
      component: () => import('@v2/components/mall/Index')
    },
    {
      path: '/mallHistory',
      name: 'mallHistory',
      component: () => import('@v2/components/mall/History')
    },
    {
      path: '/mallSecKill',
      name: 'mallSecKill',
      component: () => import('@v2/components/mall/SecKill')
    },
    {
      path: '/gradeFaq',
      name: 'gradeFaq',
      component: () => import('@v2/components/user/GradeFaq')
    },
    {
      path: '/transfer/:url',
      name: 'transfer',
      component: () => import('@v2/components/fab/Transfer')
    },
    {
      path: '/gift/exchange',
      name: 'exchange',
      component: () => import('@v2/components/gift/exchange')
    },
    {
      path: '/user/download',
      name: 'download',
      component: () => import('@v2/components/user/Download')
    }
  ]
})

router.beforeEach(function (to, from, next) {
  if (client.clientSdk) {
    client.setTitleBarShowState(true, false)
    if (platform.isQd()) {
      // 处理起点侧回退
      history.replaceState({key: '00000.000'}, true)
      client.clientSdk.inGame(true)
    }
    next()
  } else {
    console.log('sdk初始化')
    client.init(function () {
      next()
    })
  }
})

router.afterEach(function (route) {
  let url = window.location.origin + '/#' + route.fullPath
  statistic.addRecord(global.STATISTIC_ACTION_ACCESS, '', url)
})

export default router



// WEBPACK FOOTER //
// ./src/v2/router/index.js